
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, TravelTimeModel, ITravelTimeModel } from '@/services/api.service';

  import TravelTimeCreate from './TravelTimeCreate.vue';
  import TravelTimeEdit from './TravelTimeEdit.vue';

  import * as StringUtils from '@/utilities/string.utils';
  import toHoursMinutesFormatter from '@/filters/tohoursminutes.formatter';
  import toAreaTypeFormatter from '@/filters/areatype.formatter';

  @Component({
    components: {
      TravelTimeCreate,
      TravelTimeEdit
    },
    filters: {
      toHoursMinutes: toHoursMinutesFormatter,
      toAreaType: toAreaTypeFormatter
    }
  })
  export default class TravelTimeList extends Vue {
    private travelTimes: TravelTimeModel[] = [];
    private filteredTravelTimes: TravelTimeModel[] = [];
    private travelTimeInEdit: ITravelTimeModel | null = null;
    private filterCriteria: string = '';

    protected mounted() {
      this.fetchTravelTimes();
    }

    private fetchTravelTimes() {
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      const TravelTimes = clientService.getTravelTimes().then(data => {
        const sortedData = data.sort((t1, t2) => this.sortTravelTime(t1, t2));
        this.travelTimes = sortedData;
        this.applyCurrentFilter();
      });
    }

    private sortTravelTime(t1: ITravelTimeModel, t2: ITravelTimeModel) {
      if (t1.postcode === t2.postcode) {
        // locality is only important when postcodes are the same
        return (t2.locality || '') < (t1.locality || '') ? 1 : -1;
      }
      return (t1.postcode || '') > (t2.postcode || '') ? 1 : -1;
    }

    private applyCurrentFilter() {
      this.filteredTravelTimes = [];
      if (this.filterCriteria === '') {
        this.clearCurrentFilter();
        return;
      }
      this.filteredTravelTimes.push(...this.travelTimes.filter(i => this.meetsFilterCriteria(i)));
    }

    private meetsFilterCriteria(item: ITravelTimeModel): boolean {
      if (
        (item.postcode || '').toLocaleLowerCase().includes(this.filterCriteria.toLocaleLowerCase()) ||
        (item.locality || '').toLocaleLowerCase().includes(this.filterCriteria.toLocaleLowerCase())
      ) {
        return true;
      }
      return false;
    }

    private clearCurrentFilter() {
      this.filteredTravelTimes = [];
      this.filteredTravelTimes.push(...this.travelTimes);
      this.filterCriteria = '';
    }
    private onTravelTimeAddRequested() {
      console.log('EVENT:Add Travel Time requested ');
      this.$modal.show('modal-traveltime-create');
    }

    private onTravelTimeEditRequested(value: ITravelTimeModel) {
      console.log('EVENT:Edit travel time requested for ' + value.gid);
      this.travelTimeInEdit = value;
      this.$modal.show('modal-traveltime-edit');
    }
    private onTravelTimeCreated(traveltime: ITravelTimeModel) {
      // make sure this job item is for this job
      const newTravelTime = new TravelTimeModel(traveltime);
      this.travelTimes.push(newTravelTime);
      this.applyCurrentFilter();
    }

    private onTravelTimeUpdated(traveltime: ITravelTimeModel) {
      console.log('Received traveltime-updated event');
      const theTravelTime = this.travelTimes.find(item => item.gid === traveltime.gid);
      if (theTravelTime !== undefined) {
        Object.assign(theTravelTime, traveltime);
      }
    }
  }
